import { Video } from "../Store/models/Video";
import { sendGtmEvent } from "~/analytics/definitions";

export default ({ product, medium }: Video["sources"]) => {
  let pageUrl = "";
  const videoSrc = product || medium || "";
  let pageUrlEnd = -1;

  if (window.frameElement) {
    pageUrl = document.referrer;
  } else {
    pageUrl = window.location.pathname;
  }

  pageUrlEnd = pageUrl.indexOf("?");

  if (pageUrlEnd > 0) {
    pageUrl = pageUrl.substring(0, pageUrlEnd);
  }

  sendGtmEvent({
    event: "video_play",
    eventCategory: "Video Plays",
    eventAction: videoSrc,
    eventLabel: pageUrl,
  });
};
